import React from "react";
import Slider from "react-slick";

import ava01 from "../../../assets/images/ava-1.jpg";
import ava02 from "../../../assets/images/ava-2.jpg";
import ava03 from "../../../assets/images/ava-3.jpg";

import "../../../styles/Slider.css";

const TestimonialSlider = () => {
  const settings = {
    dots: true,
    autoplay: true,
    infinite: true,
    speed: 1000,
    autoplaySpeed: 3000,
    swipeToSlide: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <Slider {...settings}>
      <div>
        <p className="review__text">
          "The food was outstanding. The atmosphere was for a younger crowd as I felt old in the place, but it was a fun time. 
          Really enjoyed the experience."
        </p>
        <div className=" slider__content d-flex align-items-center gap-3 ">
          <img src={ava01} alt="avatar" className=" rounded" />
          <h6>Tola Bade</h6>
        </div>
      </div>
      <div>
        <p className="review__text">
          "Plenty of seating, beautiful surroundings, delicious food and cocktails, as well as indoor and outdoor seating options. 
          Definitely plan to go back and try some of the specialty foods."
        </p>
        <div className="slider__content d-flex align-items-center gap-3 ">
          <img src={ava02} alt="avatar" className=" rounded" />
          <h6>Seyitan Baby</h6>
        </div>
      </div>
      <div>
        <p className="review__text">
          "The food and service is on the mark. Pricing is in line with the experience. Valet is reasonable and very efficient."
        </p>
        <div className="slider__content d-flex align-items-center gap-3 ">
          <img src={ava03} alt="avatar" className=" rounded" />
          <h6>Nana Dee</h6>
        </div>
      </div>
    </Slider>
  );
};

export default TestimonialSlider;
